// Chartkick + Chart.js (and date-fns adapter) for admin analytics charts.
// Views use inline <script type="module"> that calls new Chartkick.* — those run as
// separate modules and need Chartkick on window (see ChartkickHelper).
import Chartkick from "chartkick"
import "chartkick/chart.js"
import { Chart } from "chart.js"

// Chart.js has no reliable option for “pixels between x-axis labels and bottom legend”.
// Opt in per chart via options.plugins.legendBottomGap (number, from Ruby JSON).
const legendBottomGapPlugin = {
  id: "legendBottomGap",
  afterLayout(chart) {
    const gap = chart.options.plugins?.legendBottomGap
    if (typeof gap !== "number" || gap <= 0) return
    const leg = chart.legend
    if (!leg || leg.options.display === false) return
    if (leg.options.position !== "bottom") return
    if (typeof leg.top !== "number" || !Number.isFinite(leg.top)) return
    leg.top += gap
  },
}

// y1 is only for mirrored tick labels; no datasets use it, so Chart.js would otherwise pick a wrong domain.
// Opt in with options.plugins.mirrorYAxisTicks (boolean from Ruby JSON).
function syncMirroredYAxisTicks(secondary, primary) {
  secondary.min = primary.min
  secondary.max = primary.max
  secondary.ticks = primary.ticks.map((t) => Object.assign({}, t))
}

const mirrorYAxisTicksPlugin = {
  id: "mirrorYAxisTicks",
  // y1 must run after y so primary.ticks exist; then replace y1’s auto domain (no datasets use y1).
  afterBuildTicks(chart, args) {
    if (!chart.options.plugins?.mirrorYAxisTicks) return
    if (args.scale.id !== "y1") return

    const primary = chart.scales.y
    const secondary = args.scale
    if (!primary?.ticks?.length) return

    syncMirroredYAxisTicks(secondary, primary)
  },
}

Chart.register(legendBottomGapPlugin)
Chart.register(mirrorYAxisTicksPlugin)

window.Chartkick = Chartkick
